import React, { useState } from 'react';
import { Alert, Collapse, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import LanguageIcon from '@mui/icons-material/Language';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

export function Alerts({ noMenu, readOnly }) {
  const { t } = useTranslation();
  const [showNoLanguageAlert, setShowNoLanguageAlert] = useState(true);
  const [showReadOnlyAlert, setShowReadOnlyAlert] = useState(true);

  return (
    <>
      {noMenu && (
        <Collapse in={showNoLanguageAlert}>
            <Alert
            severity="info"
            iconMapping={{
                info: <LanguageIcon fontSize="inherit" />
            }}
            action={
                <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => setShowNoLanguageAlert(false)}
                >
                <CloseIcon fontSize="inherit" />
                </IconButton>
            }
            sx={{
                backgroundColor: '#FFFFFF',
                color: '#4B7359',
                '& .MuiAlert-icon': {
                color: '#4B7359',
                },
            }}
            >
            {t('noMenuLanuageError')}
            </Alert>
        </Collapse>
      )}

      {readOnly && (
        <Collapse in={showReadOnlyAlert}>
          <Alert
            severity="info"
            iconMapping={{
              info: <AutoStoriesIcon fontSize="inherit" />
            }}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => setShowReadOnlyAlert(false)}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{
              mt: 1,
              backgroundColor: '#FFFFFF',
              color: '#4B7359',
              '& .MuiAlert-icon': {
                color: '#4B7359',
              },
            }}
          >
            {t('readOnlyMenu')}
          </Alert>
        </Collapse>
      )}
    </>
  );
};
